import DocumentLinksPage from "../components/DocumentLinksPage.jsx";

const documents = [
	{
		label: "MOG di Ceres",
		href: "/MOG-2026.pdf",
	},
	{
		label: "MOG del birrificio San Giorgio",
		href: "/MOG-birrificio-san-giorgio.pdf",
	},
];

const CorporateGovernance = () => {
	return (
		<DocumentLinksPage
			title="Corporate Governance"
			intro="Consulta i documenti di corporate governance disponibili per Ceres e per il birrificio San Giorgio."
			documents={documents}
		/>
	);
};

export default CorporateGovernance;
